import React, { useCallback, useEffect, useState } from 'react';

import notification from 'antd/lib/notification';

import { User, getCore } from 'cvat-core-wrapper';
import { AnalyticsDsQuery } from 'cvat-core/src/analytics-report';

import MetricsModal, { MetricsType } from 'components/metrics/metrics-modal';
import CVATLoadingSpinner from 'components/common/loading-spinner';

interface Props {
    instansName: string,
    instansId: number,
    from?: string,
    to?: string,
    changeMetricsVisible(elem: boolean): void,
}

const core = getCore();

function Metrics(props: Props): JSX.Element {

    const {
        instansName,
        instansId,
        from,
        to,
        changeMetricsVisible
    } = props;

    const [metricsModalVisible, setMetricsModalVisible] = useState(false);
    const [metrics, setMetrics] = useState<MetricsType[]>([]);
    const [isLoadTableDataSpin, setIsLoadTableDataSpin] = useState(false);
    const [isLoadingMetrics, setIsLoadingMetrics] = useState(false);
    const [savedInstansName, setSavedInstansName] = useState<string>();
    const [savedInstansId, setSavedInstansId] = useState<number>();

    const getMetrics = async (instansName: string, instansId: number, from?: string, to?: string): Promise<void> => {
        try {
            if (!from) setIsLoadingMetrics(true)
            const datasources = await core.analytics.performance.datasources();

            const uid = datasources?.uid;

            const users = await core.users.get();
            const usersIdArray = users.map((user: User) => user.id);

            if (uid && instansId) {
                const promises = usersIdArray.map(async (user_id: number) => {
                    const dataPlus = await core.analytics.performance.query({
                        user_id,
                        uid,
                        instans_name: instansName,
                        instans_id: instansId,
                        from,
                        to,
                    });
                    return dataPlus;
                });

                const results = await Promise.all(promises);

                const existingResults = results.filter((elem: AnalyticsDsQuery) => elem.totalShapes || elem.totalTracks);

                if (existingResults.length) {
                    setMetrics(() => {
                        const metrics: MetricsType[] = [];

                        users.forEach((user: User) => {
                            metrics.push({
                                key: user.username,
                                user: user,
                            });
                        });

                        existingResults.forEach((elem: AnalyticsDsQuery, index) => {
                            metrics[index].boxes = elem.totalShapes + elem.totalTracks;
                        });

                        return metrics.filter((metric: MetricsType) => metric.boxes);
                    })
                } else {
                    changeMetricsVisible(false);
                    notification.warning({
                        message: 'Не удалось получить метрики',
                        description: 'Ещё не создано ни одной разметки',
                    });
                }
            }
            setIsLoadingMetrics(false);
            setIsLoadTableDataSpin(false);


        } catch (error: unknown) {
            setIsLoadingMetrics(false);
            setIsLoadTableDataSpin(false);
            changeMetricsVisible(false);
            notification.error({
                message: 'Не удалось получить метрики',
                description: `${error instanceof Error ? error.message : ''}`,
            });
        }
    };

    useEffect(() => {
        if (instansName && instansId) {
            setSavedInstansName(instansName);
            setSavedInstansId(instansId);
            getMetrics(instansName, instansId, from, to);
        }
    }, [instansName, instansId]);

    useEffect(() => {
        if (metrics.length) {
            setMetricsModalVisible(true);
        }
    }, [metrics]);

    const changeRangeTime = async (time: string[]) => {
        setIsLoadTableDataSpin(true);
        if (savedInstansName && savedInstansId) getMetrics(savedInstansName, savedInstansId, time[0], time[1]);
    };

    const closeMetrics = useCallback(() => {
        setMetricsModalVisible(false);
        changeMetricsVisible(false);
    }, []);

    return (
        <>
            <div className='cvat-space' style={{height: '100%'}}>
                {isLoadingMetrics && <CVATLoadingSpinner />}
            </div>

            <MetricsModal
                visible={metricsModalVisible}
                onClose={closeMetrics}
                metrics={metrics}
                loadTableDataSpin={isLoadTableDataSpin}
                changeRangeTime={changeRangeTime}
                instansName={instansName}
            />
        </>
    );
}

export default React.memo(Metrics);
